// WE, ROBOT - Robot Database
// Contains all robots (real + decoys) with names, alternate names, sources, and whether they're in the image
// inImage: true = robot is in the collection image
// inImage: false = decoy robot (not in image, triggers penalty)

// GAME CONFIGURATION
const gameConfig = {
    // Main game identity
    gameTitle: "WE, ROBOT",
    subjectPlural: "robots",        // "robots", "aliens", "rockstars", etc.
    subjectSingular: "robot",       // "robot", "alien", "rockstar", etc.
    subjectCapPlural: "ROBOTS",     // "ROBOTS", "ALIENS", "ROCKSTARS", etc.
    subjectCapSingular: "ROBOT",    // "ROBOT", "ALIEN", "ROCKSTAR", etc.
    
    // Calculated from database (will be set programmatically)
    totalCount: 91,
    
    // UI Text Templates
    subtitle: "FIND {count} FAMOUS {subjects}",
    instructionsTop: "Study the {subject} silhouettes and enter their names below...",
    instructionsBottom: "Type at least three characters and options will appear. Select from the list or hit return to enter your guess. Beware: some options are decoys. Find all <strong>{count}</strong> {subjects} to win! Use the links at the end to post your score.",
    
    // Game mechanics
    revealThresholdPercent: 75,
    
    // Messages
    correctMessage: "🎯 Correct! {name} identified!",
    notInCollectionMessage: "❌ {name} is not in the collection.",
    alreadyFoundMessage: "You already found {name}!",
    missionCompleteMessage: "🎉 MISSION COMPLETE! All {subjects} found!",
    revealUnlockMessage: "You've found {percent}% of {subjects} - Reveal option unlocked!",
    revealProgressMessage: "Find {threshold}% of {subjects} to unlock Reveal option (currently {percent}%)",
    quitUnlockMessage: "Find {threshold}% of {subjects} to unlock Reveal option",
    
    // Share text templates
    shareText: "{accuracy}% accuracy - found {found} of {total} {subjects} in {title}! Can you beat me?",
    shareCallToAction: "Can you find all {total} {subjects}?",
    
    // URLs
    gameUrl: "https://www.chopshopstore.com/pages/robot-game",
    shopBaseUrl: "https://www.chopshopstore.com"
};

const robotDatabase = [
    // ===== ROBOTS IN THE IMAGE (inImage: true) =====
        
        //Possible New Additions
        
    // Murder Robot franchise
    { name: "Murderbot", officialName: "Murderbot", source: "Murderbot", inImage: false },
    { name: "Murder Robot", officialName: "Murderbot", source: "Murderbot", inImage: false },
    { name: "SecUnit", officialName: "Murderbot", source: "Murderbot", inImage: false },
    { name: "Security Unit", officialName: "Murderbot", source: "Murderbot", inImage: false },
    
    // Wild Robot
    { name: "Roz", officialName: "Rozzum", source: "Wild Robot", inImage: false },
    { name: "Rozzum", officialName: "Rozzum", source: "Wild Robot", inImage: false },
    { name: "Unit 7134", officialName: "Rozzum", source: "Wild Robot", inImage: false },
    { name: "7134", officialName: "Rozzum", source: "Wild Robot", inImage: false },
    { name: "Wild Robot", officialName: "Rozzum", source: "Wild Robot", inImage: false },
    { name: "Vontra", officialName: "Vontra", source: "Wild Robot", inImage: false },
    { name: "RECO", officialName: "RECO", source: "Wild Robot", inImage: false },
    { name: "Unit 6262", officialName: "Unit 6262", source: "Wild Robot", inImage: false },
        
    //IN THE GAME
    
    // R2-D2
    { name: "R2-D2", officialName: "R2-D2", source: "Star Wars", inImage: true },
    { name: "R2D2", officialName: "R2-D2", source: "Star Wars", inImage: true },
    { name: "Artoo", officialName: "R2-D2", source: "Star Wars", inImage: true },
    { name: "Detoo", officialName: "R2-D2", source: "Star Wars", inImage: true },
    { name: "R2", officialName: "R2-D2", source: "Star Wars", inImage: true },
    
    // C3PO
    { name: "C3PO", officialName: "C3PO", source: "Star Wars", inImage: true },
    { name: "C-3PO", officialName: "C3PO", source: "Star Wars", inImage: true },
    { name: "Threepio", officialName: "C3PO", source: "Star Wars", inImage: true },
    { name: "3PO", officialName: "C3PO", source: "Star Wars", inImage: true },
    
    // WALL-E
    { name: "WALL-E", officialName: "WALL-E", source: "WALL-E", inImage: true },
    { name: "WALLE", officialName: "WALL-E", source: "WALL-E", inImage: true },
    { name: "Wall E", officialName: "WALL-E", source: "WALL-E", inImage: true },
    { name: "Wally", officialName: "WALL-E", source: "WALL-E", inImage: true },
    { name: "Eve", officialName: "Eve", source: "WALL-E", inImage: false },
    
    // Bender
    { name: "Bender", officialName: "Bender", source: "Futurama", inImage: true },
    { name: "Bender Rodriguez", officialName: "Bender", source: "Futurama", inImage: true },
    { name: "Futurama", officialName: "Bender", source: "Futurama", inImage: true },
    { name: "Bending Unit 22", officialName: "Bender", source: "Futurama", inImage: true },
    
    // Baymax
    { name: "Baymax", officialName: "Baymax", source: "Big Hero 6", inImage: true },
    
    // HAL 2001
    { name: "HAL 2001", officialName: "HAL 2001", source: "2001: a Space Odyssey", inImage: true },
    { name: "HAL 9000", officialName: "HAL 2001", source: "2001: a Space Odyssey", inImage: true },
    { name: "HAL", officialName: "HAL 2001", source: "2001: a Space Odyssey", inImage: true },
    
    // Iron Giant
    { name: "Iron Giant", officialName: "Iron Giant", source: "The Iron Giant", inImage: true },
    { name: "The Iron Giant", officialName: "Iron Giant", source: "The Iron Giant", inImage: true },
    { name: "Giant", officialName: "Iron Giant", source: "The Iron Giant", inImage: true },
    
    // Optimus Prime  
    { name: "Optimus Prime", officialName: "Optimus Prime", source: "Transformers", inImage: true },
    { name: "Optimus", officialName: "Optimus Prime", source: "Transformers", inImage: true },
    { name: "Prime", officialName: "Optimus Prime", source: "Transformers", inImage: true },
    { name: "Transformers", officialName: "Optimus Prime", source: "Transformers", inImage: true },
    
    // K-9
    { name: "K-9", officialName: "K-9", source: "Doctor Who", inImage: true },
    { name: "K9", officialName: "K-9", source: "Doctor Who", inImage: true },
    { name: "Dr Who", officialName: "K-9", source: "Doctor Who", inImage: true },
    { name: "Dr. Who", officialName: "K-9", source: "Doctor Who", inImage: true },
    { name: "DrWho", officialName: "K-9", source: "Doctor Who", inImage: true },
    { name: "Doctor Who", officialName: "K-9", source: "Doctor Who", inImage: true },
    { name: "Doctor Who Dog", officialName: "K-9", source: "Doctor Who", inImage: true },
    
    // Samantha
    { name: "Samantha", officialName: "Samantha", source: "Her", inImage: true },
    { name: "Sam", officialName: "Samantha", source: "Her", inImage: true },
    
    // Box
    { name: "Box", officialName: "Box", source: "Logan's Run", inImage: true },
    
    // Butter Robot
    { name: "Butter Robot", officialName: "Butter Robot", source: "Rick & Morty", inImage: true },
    { name: "Butter Bot", officialName: "Butter Robot", source: "Rick & Morty", inImage: true },
    
    // 7-zark-7
    { name: "7-zark-7", officialName: "7-zark-7", source: "Battle of the Planets", inImage: true },
    { name: "Zark", officialName: "7-zark-7", source: "Battle of the Planets", inImage: true },
    
    // IQ-9
    { name: "IQ-9", officialName: "IQ-9", source: "Star Blazers", inImage: true },
    { name: "IQ9", officialName: "IQ-9", source: "Star Blazers", inImage: true },
    
    // Linguo
    { name: "Linguo", officialName: "Linguo", source: "The Simpsons", inImage: true },
    
    // MCP
    { name: "MCP", officialName: "MCP", source: "Tron", inImage: true },
    { name: "Master Control Program", officialName: "MCP", source: "Tron", inImage: true },
    
    // The Wrong Trousers
    { name: "The Wrong Trousers", officialName: "The Wrong Trousers", source: "Wallace & Gromit", inImage: true },
    { name: "Wrong Trousers", officialName: "The Wrong Trousers", source: "Wallace & Gromit", inImage: true },
    { name: "Pants", officialName: "The Wrong Trousers", source: "Wallace & Gromit", inImage: true },
    { name: "Trousers", officialName: "The Wrong Trousers", source: "Wallace & Gromit", inImage: true },

    // Tom Servo
    { name: "Tom Servo", officialName: "Tom Servo", source: "Mystery Science Theater 3000", inImage: true },
    { name: "Servo", officialName: "Tom Servo", source: "Mystery Science Theater 3000", inImage: true },
    { name: "Mystery Science", officialName: "Tom Servo", source: "Mystery Science Theater 3000", inImage: true },
    { name: "Mystery Science Theater 3000", officialName: "Tom Servo", source: "Mystery Science Theater 3000", inImage: true },
    { name: "MST3K", officialName: "Tom Servo", source: "Mystery Science Theater 3000", inImage: true },
    { name: "MST", officialName: "Tom Servo", source: "Mystery Science Theater 3000", inImage: true },
    
    // Crow
    { name: "Crow", officialName: "Crow", source: "Mystery Science Theater 3000", inImage: true },
    { name: "Crow T Robot", officialName: "Crow", source: "Mystery Science Theater 3000", inImage: true },
    { name: "Crow T. Robot", officialName: "Crow", source: "Mystery Science Theater 3000", inImage: true },
    
    // B-9
    { name: "B-9", officialName: "B-9", source: "Lost in Space", inImage: true },
    { name: "B9", officialName: "B-9", source: "Lost in Space", inImage: true },
    { name: "Lost in Space", officialName: "B-9", source: "Lost in Space", inImage: true },
    
    // Bomberman
    { name: "Bomberman", officialName: "Bomberman", source: "Bomberman", inImage: true },
    { name: "Bomb Man", officialName: "Bomberman", source: "Bomberman", inImage: true },
    
    // MegaMan
    { name: "MegaMan", officialName: "MegaMan", source: "MegaMan", inImage: true },
    { name: "Mega Man", officialName: "MegaMan", source: "MegaMan", inImage: true },
    { name: "Rockman", officialName: "MegaMan", source: "MegaMan", inImage: true },
    { name: "Rock Man", officialName: "MegaMan", source: "MegaMan", inImage: true },
    
    // Robby the Robot
    { name: "Robby the Robot", officialName: "Robby the Robot", source: "Forbidden Planet", inImage: true },
    { name: "Robby", officialName: "Robby the Robot", source: "Forbidden Planet", inImage: true },
    { name: "Forbidden Planet", officialName: "Robby the Robot", source: "Forbidden Planet", inImage: true },
    
    // Mr. Roboto
    { name: "Mr. Roboto", officialName: "Mr. Roboto", source: "Styx", inImage: true },
    { name: "Mr Roboto", officialName: "Mr. Roboto", source: "Styx", inImage: true },
    { name: "Mister Roboto", officialName: "Mr. Roboto", source: "Styx", inImage: true },
    { name: "Styx", officialName: "Mr. Roboto", source: "Styx", inImage: true },
    
    // Six
    { name: "Six", officialName: "Six", source: "Battlestar Galactica", inImage: true },
    { name: "Number Six", officialName: "Six", source: "Battlestar Galactica", inImage: true },
    { name: "Battlestar Galactica", officialName: "Six", source: "Battlestar Galactica", inImage: true },
    { name: "Tricia Helfer", officialName: "Six", source: "Battlestar Galactica", inImage: true },
    
    // Enemy Robot
    { name: "Enemy Robot", officialName: "Enemy Robot", source: "Berzerk", inImage: true },
    { name: "Enemy", officialName: "Enemy Robot", source: "Berzerk", inImage: true },
    { name: "Berzerk", officialName: "Enemy Robot", source: "Berzerk", inImage: true },
    
    // Sad Robot
    { name: "Sad Robot", officialName: "Sad Robot", source: "Queen - News of the World", inImage: true },
    { name: "Sad", officialName: "Sad Robot", source: "Queen - News of the World", inImage: true },
    { name: "Queen", officialName: "Sad Robot", source: "Queen - News of the World", inImage: true },
    { name: "News of the World", officialName: "Sad Robot", source: "Queen - News of the World", inImage: true },
    { name: "News", officialName: "Sad Robot", source: "Queen - News of the World", inImage: true },
    
    // Toy Robot
    { name: "Toy Robot", officialName: "Toy Robot", source: "Rock'em Sock'em Robots", inImage: true },
    { name: "Toy", officialName: "Toy Robot", source: "Rock'em Sock'em Robots", inImage: true },
    { name: "Rock'em Sock'em Robots", officialName: "Toy Robot", source: "Rock'em Sock'em Robots", inImage: true },
    { name: "Rockem Sockem Robots", officialName: "Toy Robot", source: "Rock'em Sock'em Robots", inImage: true },
    { name: "Rock em Sock em", officialName: "Toy Robot", source: "Rock'em Sock'em Robots", inImage: true },
    { name: "Rockem Sockem", officialName: "Toy Robot", source: "Rock'em Sock'em Robots", inImage: true },
    
    // Meccagodzilla
    { name: "Meccagodzilla", officialName: "Meccagodzilla", source: "Godzilla", inImage: true },
    { name: "MechaGodzilla", officialName: "Meccagodzilla", source: "Godzilla", inImage: true },
    { name: "Mechagodzilla", officialName: "Meccagodzilla", source: "Godzilla", inImage: true },
    { name: "Godzilla", officialName: "Meccagodzilla", source: "Godzilla", inImage: true },
    
    // Gigantor
    { name: "Gigantor", officialName: "Gigantor", source: "Gigantor", inImage: true },
    { name: "Tetsujin 28", officialName: "Gigantor", source: "Gigantor", inImage: true },
    
    // Robotron: 2084
    { name: "Robotron: 2084", officialName: "Robotron: 2084", source: "Robotron: 2084", inImage: true },
    { name: "Robotron", officialName: "Robotron: 2084", source: "Robotron: 2084", inImage: true },
    { name: "Robotron 2084", officialName: "Robotron: 2084", source: "Robotron: 2084", inImage: true },

    // E-102 Gamma
    { name: "E-102 Gamma", officialName: "E-102 Gamma", source: "Sonic Adventure", inImage: true },
    { name: "E102 Gamma", officialName: "E-102 Gamma", source: "Sonic Adventure", inImage: true },
    { name: "Gamma", officialName: "E-102 Gamma", source: "Sonic Adventure", inImage: true },
    { name: "Sonic", officialName: "E-102 Gamma", source: "Sonic Adventure", inImage: true },
    
    // Robot Shooty Thing
    { name: "Robot Shooty Thing", officialName: "Robot Shooty Thing", source: "Steven Universe", inImage: true },
    { name: "Shooty Thing", officialName: "Robot Shooty Thing", source: "Steven Universe", inImage: true },
    { name: "Steven Universe", officialName: "Robot Shooty Thing", source: "Steven Universe", inImage: true },
    
    // Chappie
    { name: "Chappie", officialName: "Chappie", source: "Chappie", inImage: true },
    
    // BMO
    { name: "BMO", officialName: "BMO", source: "Adventure Time", inImage: true },
    { name: "Beemo", officialName: "BMO", source: "Adventure Time", inImage: true },
    { name: "B-MO", officialName: "BMO", source: "Adventure Time", inImage: true },
    
    // BrainBots
    { name: "BrainBots", officialName: "BrainBots", source: "Megamind", inImage: true },
    { name: "Brain Bots", officialName: "BrainBots", source: "Megamind", inImage: true },
    { name: "Brainbot", officialName: "BrainBots", source: "Megamind", inImage: true },
    { name: "Megamind", officialName: "BrainBots", source: "Megamind", inImage: true },
    
    // Wheatley
    { name: "Wheatley", officialName: "Wheatley", source: "Portal", inImage: true },
    { name: "Portal", officialName: "Wheatley", source: "Portal", inImage: true },
    
    // MSE-6
    { name: "MSE-6", officialName: "MSE-6", source: "Star Wars", inImage: true },
    { name: "MSE6", officialName: "MSE-6", source: "Star Wars", inImage: true },
    { name: "Mouse Droid", officialName: "MSE-6", source: "Star Wars", inImage: true },
    { name: "Repair Droid", officialName: "MSE-6", source: "Star Wars", inImage: true },
    
    // Gerty
    { name: "Gerty", officialName: "Gerty", source: "Moon", inImage: true },
    { name: "GERTY", officialName: "Gerty", source: "Moon", inImage: true },
    { name: "Moon", officialName: "Gerty", source: "Moon", inImage: true },
    
    // Micro Manager
    { name: "Micro Manager", officialName: "Micro Manager", source: "The Lego Movie", inImage: true },
    { name: "Micromanager", officialName: "Micro Manager", source: "The Lego Movie", inImage: true },
    { name: "Micro-Manager", officialName: "Micro Manager", source: "The Lego Movie", inImage: true },
    { name: "Lego Movie", officialName: "Micro Manager", source: "The Lego Movie", inImage: true },
    
    // Metalhead
    { name: "Metalhead", officialName: "Metalhead", source: "Black Mirror", inImage: true },
    { name: "Metal Head", officialName: "Metalhead", source: "Black Mirror", inImage: true },
    { name: "Black Mirror", officialName: "Metalhead", source: "Black Mirror", inImage: true },
    
    // Gunslinger
    { name: "Gunslinger", officialName: "Gunslinger", source: "Westworld Original", inImage: true },
    { name: "The Gunslinger", officialName: "Gunslinger", source: "Westworld Original", inImage: true },
    { name: "Westworld", officialName: "Gunslinger", source: "Westworld Original", inImage: true },
    { name: "Westworld Original", officialName: "Gunslinger", source: "Westworld Original", inImage: true },
    { name: "Yul Brynner", officialName: "Gunslinger", source: "Westworld Original", inImage: true },
    
    // Astro Boy
    { name: "Astro Boy", officialName: "Astro Boy", source: "Astro Boy", inImage: true },
    { name: "Astroboy", officialName: "Astro Boy", source: "Astro Boy", inImage: true },
    { name: "Atom", officialName: "Astro Boy", source: "Astro Boy", inImage: true },
    { name: "Mighty Atom", officialName: "Astro Boy", source: "Astro Boy", inImage: true },
    
    // 80s Robot
    { name: "80s Robot", officialName: "80s Robot", source: "The Muppets", inImage: true },
    { name: "Eighties Robot", officialName: "80s Robot", source: "The Muppets", inImage: true },
    { name: "1980s Robot", officialName: "80s Robot", source: "The Muppets", inImage: true },
    { name: "Muppets", officialName: "80s Robot", source: "The Muppets", inImage: true },
    
    // Johnny-5
    { name: "Johnny-5", officialName: "Johnny-5", source: "Short Circuit", inImage: true },
    { name: "Johnny 5", officialName: "Johnny-5", source: "Short Circuit", inImage: true },
    { name: "Johnny Five", officialName: "Johnny-5", source: "Short Circuit", inImage: true },
    { name: "Number 5", officialName: "Johnny-5", source: "Short Circuit", inImage: true },
    { name: "Number Five", officialName: "Johnny-5", source: "Short Circuit", inImage: true },
    { name: "Short Circuit", officialName: "Johnny-5", source: "Short Circuit", inImage: true },
    
    // Interrogator
    { name: "Interrogator", officialName: "Interrogator", source: "Star Wars", inImage: true },
    { name: "Interrogation Droid", officialName: "Interrogator", source: "Star Wars", inImage: true },
    { name: "IT-O", officialName: "Interrogator", source: "Star Wars", inImage: true },
    
    // V.I.N.CENT
    { name: "V.I.N.CENT", officialName: "V.I.N.CENT", source: "The Black Hole", inImage: true },
    { name: "Vincent", officialName: "V.I.N.CENT", source: "The Black Hole", inImage: true },
    { name: "VINCENT", officialName: "V.I.N.CENT", source: "The Black Hole", inImage: true },
    { name: "V.I.N.C.E.N.T.", officialName: "V.I.N.CENT", source: "The Black Hole", inImage: true },
    { name: "Black Hole", officialName: "V.I.N.CENT", source: "The Black Hole", inImage: true },
    
    // Tripod
    { name: "Tripod", officialName: "Tripod", source: "War of the Worlds", inImage: true },
    { name: "War Machine", officialName: "Tripod", source: "War of the Worlds", inImage: true },
    { name: "Martian Machine", officialName: "Tripod", source: "War of the Worlds", inImage: true },
    { name: "Fighting Machine", officialName: "Tripod", source: "War of the Worlds", inImage: true },
    { name: "War of the Worlds", officialName: "Tripod", source: "War of the Worlds", inImage: true },
    
    // Daggit
    { name: "Daggit", officialName: "Daggit", source: "Battlestar Galactica Original", inImage: true },
    { name: "Muffit", officialName: "Daggit", source: "Battlestar Galactica Original", inImage: true },
    
    // NEPTOR
    { name: "NEPTOR", officialName: "NEPTOR", source: "Adventure Time", inImage: true },
    { name: "Neptor", officialName: "NEPTOR", source: "Adventure Time", inImage: true },
    { name: "NEPTR", officialName: "NEPTOR", source: "Adventure Time", inImage: true },
    { name: "Neptr", officialName: "NEPTOR", source: "Adventure Time", inImage: true },
    { name: "Never Ending Pie Throwing Robot", officialName: "NEPTOR", source: "Adventure Time", inImage: true },
    
    // Konky
    { name: "Konky", officialName: "Konky", source: "Pee-Wee's Playhouse", inImage: true },
    { name: "Conky", officialName: "Konky", source: "Pee-Wee's Playhouse", inImage: true },
    { name: "Pee-Wee", officialName: "Konky", source: "Pee-Wee's Playhouse", inImage: true },
    
    // Teddy
    { name: "Teddy", officialName: "Teddy", source: "A.I. Artificial Intelligence", inImage: true },
    { name: "Teddy Bear Robot", officialName: "Teddy", source: "A.I. Artificial Intelligence", inImage: true },
    { name: "Super Toy", officialName: "Teddy", source: "A.I. Artificial Intelligence", inImage: true },
    { name: "A.I.", officialName: "Teddy", source: "A.I. Artificial Intelligence", inImage: true },
    { name: "AI", officialName: "Teddy", source: "A.I. Artificial Intelligence", inImage: true },
    { name: "Artificial Intelligence", officialName: "Teddy", source: "A.I. Artificial Intelligence", inImage: true },
    
    // Plex
    { name: "Plex", officialName: "Plex", source: "Yo Gabba Gabba!", inImage: true },
    { name: "Plex Robot", officialName: "Plex", source: "Yo Gabba Gabba!", inImage: true },
    { name: "Yo Gabba Gabba", officialName: "Plex", source: "Yo Gabba Gabba!", inImage: true },
    
    // K-2SO
    { name: "K-2SO", officialName: "K-2SO", source: "Star Wars: Rogue One", inImage: true },
    { name: "K2SO", officialName: "K-2SO", source: "Star Wars: Rogue One", inImage: true },
    { name: "K 2SO", officialName: "K-2SO", source: "Star Wars: Rogue One", inImage: true },
    { name: "Kaytoo", officialName: "K-2SO", source: "Star Wars: Rogue One", inImage: true },
    { name: "Rogue One", officialName: "K-2SO", source: "Star Wars: Rogue One", inImage: true },
    
    // Alicia
    { name: "Alicia", officialName: "Alicia", source: "The Twilight Zone", inImage: true },
    { name: "Twilight Zone", officialName: "Alicia", source: "The Twilight Zone", inImage: true },
    
    // Cylon Warrior
    { name: "Cylon Warrior", officialName: "Cylon Warrior", source: "Battlestar Galactica (2004)", inImage: true },
    { name: "Battlestar Galactica 2004", officialName: "Cylon Warrior", source: "Battlestar Galactica (2004)", inImage: true },
    { name: "BSG 2004", officialName: "Cylon Warrior", source: "Battlestar Galactica (2004)", inImage: true },
    
    // Kryten
    { name: "Kryten", officialName: "Kryten", source: "Red Dwarf", inImage: true },
    { name: "Red Dwarf", officialName: "Kryten", source: "Red Dwarf", inImage: true },
    
    // Mazinga
    { name: "Mazinga", officialName: "Mazinga", source: "Mazinger Z", inImage: true },
    { name: "Mazinga Shogun", officialName: "Mazinga", source: "Mazinger Z", inImage: true },
    { name: "Mazinga Toy", officialName: "Mazinga", source: "Mazinger Z", inImage: true },
    { name: "Mazinger Z", officialName: "Mazinga", source: "Mazinger Z", inImage: true },
    { name: "Mazinger", officialName: "Mazinga", source: "Mazinger Z", inImage: true },
    
    // Bubo
    { name: "Bubo", officialName: "Bubo", source: "Clash of the Titans", inImage: true },
    { name: "Clash of the Titans", officialName: "Bubo", source: "Clash of the Titans", inImage: true },
    
    // BB-8
    { name: "BB-8", officialName: "BB-8", source: "Star Wars", inImage: true },
    { name: "BB8", officialName: "BB-8", source: "Star Wars", inImage: true },
    { name: "Beebee-Eight", officialName: "BB-8", source: "Star Wars", inImage: true },
    
    // Servant Robot
    { name: "Servant Robot", officialName: "Servant Robot", source: "Sleeper", inImage: true },
    { name: "Sleeper", officialName: "Servant Robot", source: "Sleeper", inImage: true },
    { name: "Woody Allen", officialName: "Servant Robot", source: "Sleeper", inImage: true },
    
    // Cylon
    { name: "Cylon", officialName: "Cylon", source: "Battlestar Galactica Original", inImage: true },
    { name: "Original Cylon", officialName: "Cylon", source: "Battlestar Galactica Original", inImage: true },
    { name: "Cylon 1970s", officialName: "Cylon", source: "Battlestar Galactica Original", inImage: true },
    
    // Data (Star Trek)
    { name: "Data", officialName: "Data", source: "Star Trek: The Next Generation", inImage: true },
    { name: "Star Trek", officialName: "Data", source: "Star Trek: The Next Generation", inImage: true },
    { name: "Lieutenant Data", officialName: "Data", source: "Star Trek: The Next Generation", inImage: true },
    { name: "Next Generation", officialName: "Data", source: "Star Trek: The Next Generation", inImage: true },
    { name: "TNG", officialName: "Data", source: "Star Trek: The Next Generation", inImage: true },
    
    // Series 800
    { name: "Series 800", officialName: "Series 800", source: "Terminator", inImage: true },
    { name: "Terminator", officialName: "Series 800", source: "Terminator", inImage: true },
    { name: "T-800", officialName: "Series 800", source: "Terminator", inImage: true },
    { name: "T800", officialName: "Series 800", source: "Terminator", inImage: true },
    { name: "Arnold", officialName: "Series 800", source: "Terminator", inImage: true },
    { name: "Schwarzenegger", officialName: "Series 800", source: "Terminator", inImage: true },
    
    // Sentinel
    { name: "Sentinel", officialName: "Sentinel", source: "The Matrix", inImage: true },
    { name: "Matrix", officialName: "Sentinel", source: "The Matrix", inImage: true },
    { name: "The Matrix", officialName: "Sentinel", source: "The Matrix", inImage: true },
    
    // Sonny
    { name: "Sonny", officialName: "Sonny", source: "I, Robot", inImage: true },
    { name: "I Robot", officialName: "Sonny", source: "I, Robot", inImage: true },
    { name: "I, Robot", officialName: "Sonny", source: "I, Robot", inImage: true },
    
    // Ultron
    { name: "Ultron", officialName: "Ultron", source: "Marvel", inImage: true },
    { name: "Marvel", officialName: "Ultron", source: "Marvel", inImage: true },
    { name: "Avengers", officialName: "Ultron", source: "Marvel", inImage: true },
    
    // Jet Jaguar
    { name: "Jet Jaguar", officialName: "Jet Jaguar", source: "Godzilla", inImage: true },
    
    // Santabot
    { name: "Santabot", officialName: "Santabot", source: "Futurama", inImage: true },
    { name: "Santa Bot", officialName: "Santabot", source: "Futurama", inImage: true },
    { name: "Robot Santa", officialName: "Santabot", source: "Futurama", inImage: true },
    
    // Maschinenmensch
    { name: "Maschinenmensch", officialName: "Maschinenmensch", source: "Metropolis", inImage: true },
    { name: "Metropolis", officialName: "Maschinenmensch", source: "Metropolis", inImage: true },
    { name: "Maria", officialName: "Maschinenmensch", source: "Metropolis", inImage: true },
    
    // Gort
    { name: "Gort", officialName: "Gort", source: "The Day the Earth Stood Still", inImage: true },
    { name: "Day the Earth Stood Still", officialName: "Gort", source: "The Day the Earth Stood Still", inImage: true },
    { name: "Klatuu's Robot", officialName: "Gort", source: "The Day the Earth Stood Still", inImage: true },
    
    // Eve (Ex Machina)
    { name: "Ava", officialName: "Ava", source: "Ex Machina", inImage: true },
    { name: "AVA", officialName: "Ava", source: "Ex Machina", inImage: true },
    { name: "Ex Machina", officialName: "Ava", source: "Ex Machina", inImage: true },
    { name: "Ave", officialName: "Ava", source: "Ex Machina", inImage: true },
    
    // Flying Robot
    { name: "Flying Robot", officialName: "Flying Robot", source: "Johnny Sokko and His Flying Robot", inImage: true },
    { name: "Johnny Sokko", officialName: "Flying Robot", source: "Johnny Sokko and His Flying Robot", inImage: true },
    { name: "Sokko", officialName: "Flying Robot", source: "Johnny Sokko and His Flying Robot", inImage: true },
    { name: "Soko", officialName: "Flying Robot", source: "Johnny Sokko and His Flying Robot", inImage: true },
    { name: "Johnny Sokko and His Flying Robot", officialName: "Flying Robot", source: "Johnny Sokko and His Flying Robot", inImage: true },
    
    // Vision
    { name: "Vision", officialName: "Vision", source: "Marvel", inImage: false },
    
    // Mech-Prawn
    { name: "Mech-Prawn", officialName: "Mech-Prawn", source: "District 9", inImage: true },
    { name: "District 9", officialName: "Mech-Prawn", source: "District 9", inImage: true },
    { name: "Prawn Mech", officialName: "Mech-Prawn", source: "District 9", inImage: true },
    
    // TARS
    { name: "TARS", officialName: "TARS", source: "Interstellar", inImage: true },
    { name: "Interstellar", officialName: "TARS", source: "Interstellar", inImage: true },
    { name: "CASE", officialName: "TARS", source: "Interstellar", inImage: true },
    
    // Atlas
    { name: "Atlas", officialName: "Atlas", source: "Portal 2", inImage: true },
    { name: "Portal 2", officialName: "Atlas", source: "Portal 2", inImage: true },
    
    // Nomad
    { name: "Nomad", officialName: "Nomad", source: "Star Trek", inImage: true },
    
    // Tik-Tok
    { name: "Tik-Tok", officialName: "Tik-Tok", source: "Return to Oz", inImage: true },
    { name: "Return to Oz", officialName: "Tik-Tok", source: "Return to Oz", inImage: true },
    { name: "Tiktok", officialName: "Tik-Tok", source: "Return to Oz", inImage: true },
    
    // Voltron
    { name: "Voltron", officialName: "Voltron", source: "Voltron", inImage: true },
    { name: "Defender of the Universe", officialName: "Voltron", source: "Voltron", inImage: true },
    
    // Rosie the Robot
    { name: "Rosie the Robot", officialName: "Rosie the Robot", source: "The Jetsons", inImage: true },
    
    // Hector
    { name: "Hector", officialName: "Hector", source: "Saturn 3", inImage: true },
    { name: "Saturn 3", officialName: "Hector", source: "Saturn 3", inImage: true },
    
    // Sentinels
    { name: "Sentinels", officialName: "Sentinels", source: "X-Men", inImage: false },
    { name: "X-Men", officialName: "Sentinels", source: "X-Men", inImage: false },
    
    // Twiki
    { name: "Twiki", officialName: "Twiki", source: "Buck Rogers", inImage: true },
    { name: "Buck Rogers", officialName: "Twiki", source: "Buck Rogers", inImage: true },
    
    // Rusty
    { name: "Rusty", officialName: "Rusty", source: "Rusty the Boy Robot", inImage: true },
    { name: "Rusty the Boy Robot", officialName: "Rusty", source: "Rusty the Boy Robot", inImage: true },
    
    // Omnidroid 08
    { name: "Omnidroid 08", officialName: "Omnidroid 08", source: "The Incredibles", inImage: true },
    { name: "Omnidroid", officialName: "Omnidroid 08", source: "The Incredibles", inImage: true },
    { name: "Incredibles", officialName: "Omnidroid 08", source: "The Incredibles", inImage: true },
    
    // Noo Noo
    { name: "Noo Noo", officialName: "Noo Noo", source: "Teletubbies", inImage: true },
    { name: "Teletubbies", officialName: "Noo Noo", source: "Teletubbies", inImage: true },
    { name: "Noo-Noo", officialName: "Noo Noo", source: "Teletubbies", inImage: true },
    
    // Dr. Theopolis
    { name: "Dr. Theopolis", officialName: "Dr. Theopolis", source: "Buck Rogers", inImage: true },
    { name: "Dr Theopolis", officialName: "Dr. Theopolis", source: "Buck Rogers", inImage: true },
    { name: "Theopolis", officialName: "Dr. Theopolis", source: "Buck Rogers", inImage: true },
    
    // Maximilian
    { name: "Maximilian", officialName: "Maximilian", source: "The Black Hole", inImage: true },
    { name: "Max", officialName: "Maximilian", source: "The Black Hole", inImage: true },
    
    // Huey, Dewey or Louie
    { name: "Huey, Dewey or Louie", officialName: "Huey, Dewey or Louie", source: "Silent Running", inImage: true },
    { name: "Silent Running", officialName: "Huey, Dewey or Louie", source: "Silent Running", inImage: true },
    { name: "Huey", officialName: "Huey, Dewey or Louie", source: "Silent Running", inImage: true },
    { name: "Dewey", officialName: "Huey, Dewey or Louie", source: "Silent Running", inImage: true },
    { name: "Louie", officialName: "Huey, Dewey or Louie", source: "Silent Running", inImage: true },
    
    // DRD-1812
    { name: "DRD-1812", officialName: "DRD-1812", source: "Farscape", inImage: true },
    { name: "DRD", officialName: "DRD-1812", source: "Farscape", inImage: true },
    { name: "Farscape", officialName: "DRD-1812", source: "Farscape", inImage: true },
    
    // ED-209
    { name: "ED-209", officialName: "ED-209", source: "RoboCop", inImage: true },
    { name: "Series 209", officialName: "ED-209", source: "RoboCop", inImage: true },
    { name: "ED209", officialName: "ED-209", source: "RoboCop", inImage: true },
    { name: "Enforcement Droid", officialName: "ED-209", source: "RoboCop", inImage: true },
    
    // Marvin the Paranoid Android
    { name: "Marvin the Paranoid Android", officialName: "Marvin the Paranoid Android", source: "Hitchhiker's Guide", inImage: true },

    // ===== DECOY ROBOTS (inImage: false) =====
    // These robots are NOT in the image and will trigger penalties
    
    // Major decoys (well-known robots not in the image)
    // Vicki
    { name: "Vicki", officialName: "Vicki", source: "Small Wonder", inImage: false },
    { name: "Small Wonder", officialName: "Vicki", source: "Small Wonder", inImage: false },
    
    { name: "T-1000", officialName: "T-1000", source: "Terminator 2", inImage: false },
    { name: "GLaDOS", officialName: "GLaDOS", source: "Portal", inImage: false },
    { name: "Awesome-O", officialName: "Awesome-O", source: "South Park", inImage: false },
    { name: "Genetic Lifeform and Disk Operating System", officialName: "GLaDOS", source: "Portal", inImage: false },
    { name: "Claptrap", officialName: "Claptrap", source: "Borderlands", inImage: false },
    { name: "CL4P-TP", officialName: "Claptrap", source: "Borderlands", inImage: false },
    
    // Video game robots
    { name: "Clank", officialName: "Clank", source: "Ratchet & Clank", inImage: false },
    { name: "Ratchet & Clank", officialName: "Clank", source: "Ratchet & Clank", inImage: false },
    
    // Transformers decoys  
    { name: "Megatron", officialName: "Megatron", source: "Transformers", inImage: false },
    { name: "Bumblebee", officialName: "Bumblebee", source: "Transformers", inImage: false },
    { name: "Starscream", officialName: "Starscream", source: "Transformers", inImage: false },
    
    // Real-world robots
    { name: "ASIMO", officialName: "ASIMO", source: "Honda", inImage: false },
    { name: "AIBO", officialName: "AIBO", source: "Sony", inImage: false },
    
    // Other famous robots not in image
    { name: "Tin Man", officialName: "Tin Man", source: "Wizard of Oz", inImage: false },
    { name: "Wizard of Oz", officialName: "Tin Man", source: "Wizard of Oz", inImage: false },
    { name: "Tin Woodman", officialName: "Tin Man", source: "Wizard of Oz", inImage: false },

// ===== ADDITIONAL DECOY ROBOTS =====
    // Copy and paste these into your robotDatabase.js file in the decoys section
    
    // ABC Warrior
    { name: "ABC Warrior", officialName: "ABC Warrior", source: "Judge Dredd", inImage: false },
    { name: "Hammerstein", officialName: "ABC Warrior", source: "Judge Dredd", inImage: false },
    { name: "ABC Warriors", officialName: "ABC Warrior", source: "Judge Dredd", inImage: false },
    { name: "Judge Dredd", officialName: "ABC Warrior", source: "Judge Dredd", inImage: false },
    
    // ASIMO
    { name: "ASIMO", officialName: "ASIMO", source: "Honda Robotics", inImage: false },
    { name: "Advanced Step in Innovative Mobility", officialName: "ASIMO", source: "Honda Robotics", inImage: false },
    { name: "Honda Robot", officialName: "ASIMO", source: "Honda Robotics", inImage: false },
    
    // AIBO
    { name: "AIBO", officialName: "AIBO", source: "Sony", inImage: false },
    { name: "Artificial Intelligence roBOt", officialName: "AIBO", source: "Sony", inImage: false },
    { name: "Sony Dog", officialName: "AIBO", source: "Sony", inImage: false },
    
    // Amazo
    { name: "Amazo", officialName: "Amazo", source: "DC Comics", inImage: false },
    { name: "Brave and the Bold", officialName: "Amazo", source: "DC Comics", inImage: false },
    
    // Annihilants
    { name: "Annihilants", officialName: "Annihilants", source: "Flash Gordon", inImage: false },
    { name: "Flash Gordon", officialName: "Annihilants", source: "Flash Gordon", inImage: false },
    
    // Aqua
    { name: "Aqua", officialName: "Aqua", source: "Heartbeeps", inImage: false },
    { name: "Heartbeeps", officialName: "Aqua", source: "Heartbeeps", inImage: false },
    
    // Armatron
    { name: "Armatron", officialName: "Armatron", source: "Tomy", inImage: false },
    { name: "Robot Arm", officialName: "Armatron", source: "Tomy", inImage: false },
    
    // Awesome Android
    { name: "Awesome Android", officialName: "Awesome Android", source: "Marvel Comics", inImage: false },
    { name: "Mad Thinker", officialName: "Awesome Android", source: "Marvel Comics", inImage: false },
    { name: "Fantastic Four", officialName: "Awesome Android", source: "Marvel Comics", inImage: false },
    
    // B-4
    { name: "B-4", officialName: "B-4", source: "Star Trek: Nemesis", inImage: false },
    { name: "B4", officialName: "B-4", source: "Star Trek: Nemesis", inImage: false },
    { name: "Data Prototype", officialName: "B-4", source: "Star Trek: Nemesis", inImage: false },
    { name: "Nemesis", officialName: "B-4", source: "Star Trek: Nemesis", inImage: false },
    
    // Baron Karza
    { name: "Baron Karza", officialName: "Baron Karza", source: "Micronauts", inImage: false },
    { name: "Micronauts", officialName: "Baron Karza", source: "Micronauts", inImage: false },
    
    // B1 Battle Droid
    { name: "B1 Battle Droid", officialName: "B1 Battle Droid", source: "Star Wars: Prequels", inImage: false },
    { name: "Roger Roger", officialName: "B1 Battle Droid", source: "Star Wars: Prequels", inImage: false },
    { name: "Battle Droid", officialName: "B1 Battle Droid", source: "Star Wars: Prequels", inImage: false },
    { name: "Trade Federation", officialName: "B1 Battle Droid", source: "Star Wars: Prequels", inImage: false },
    
    // Bentley
    { name: "Bentley", officialName: "Bentley", source: "Fireman Sam", inImage: false },
    { name: "Fireman Sam", officialName: "Bentley", source: "Fireman Sam", inImage: false },
    
    // Braman
    { name: "Braman", officialName: "Braman", source: "Thunderbirds", inImage: false },
    { name: "Thunderbirds", officialName: "Braman", source: "Thunderbirds", inImage: false },
    { name: "Brains Robot", officialName: "Braman", source: "Thunderbirds", inImage: false },
    
    // Brainiac
    { name: "Brainiac", officialName: "Brainiac", source: "DC Comics", inImage: false },
    { name: "Superman Villain", officialName: "Brainiac", source: "DC Comics", inImage: false },
    
    // Bumblebee
    { name: "Bumblebee", officialName: "Bumblebee", source: "Transformers", inImage: false },
    { name: "Autobot", officialName: "Bumblebee", source: "Transformers", inImage: false },
    { name: "VW Beetle", officialName: "Bumblebee", source: "Transformers", inImage: false },
    { name: "Yellow Transformer", officialName: "Bumblebee", source: "Transformers", inImage: false },
    
    // Clamps
    { name: "Clamps", officialName: "Clamps", source: "Futurama", inImage: false },
    { name: "Clampbot", officialName: "Clamps", source: "Futurama", inImage: false },
    
    // Claptrap (already exists, but adding more alternates)
    { name: "CL4P-TP", officialName: "Claptrap", source: "Borderlands", inImage: false },
    { name: "Interplanetary Ninja Assassin", officialName: "Claptrap", source: "Borderlands", inImage: false },
    { name: "Borderlands", officialName: "Claptrap", source: "Borderlands", inImage: false },
    
    // Clank (already exists, but adding more)
    { name: "Ratchet & Clank", officialName: "Clank", source: "Ratchet & Clank", inImage: false },
    { name: "Ratchet and Clank", officialName: "Clank", source: "Ratchet & Clank", inImage: false },
    
    // Conroy
    { name: "Conroy", officialName: "Conroy", source: "Rick and Morty", inImage: false },
    { name: "Rick and Morty", officialName: "Conroy", source: "Rick and Morty", inImage: false },
    
    // Daimos
    { name: "Daimos", officialName: "Daimos", source: "Shogun Warriors", inImage: false },
    { name: "Shogun Warriors", officialName: "Daimos", source: "Shogun Warriors", inImage: false },
    
    // David
    { name: "David", officialName: "David", source: "A.I. Artificial Intelligence", inImage: false },
    { name: "Haley Joel Osment", officialName: "David", source: "A.I. Artificial Intelligence", inImage: false },
    { name: "Mecha", officialName: "David", source: "A.I. Artificial Intelligence", inImage: false },
    
    // D.A.R.Y.L.
    { name: "D.A.R.Y.L.", officialName: "D.A.R.Y.L.", source: "D.A.R.Y.L.", inImage: false },
    { name: "DARYL", officialName: "D.A.R.Y.L.", source: "D.A.R.Y.L.", inImage: false },
    { name: "Data-Analyzing Robot Youth Lifeform", officialName: "D.A.R.Y.L.", source: "D.A.R.Y.L.", inImage: false },
    
    // Djambi
    { name: "Djambi", officialName: "Djambi", source: "Futurama", inImage: false },
    
    // Lyle
    { name: "Lyle", officialName: "Lyle", source: "Family Guy", inImage: false },
    { name: "Family Guy", officialName: "Lyle", source: "Family Guy", inImage: false },
    
    // Super-Automated Machine
    { name: "Super-Automated Machine", officialName: "Super-Automated Machine", source: "Sesame Street", inImage: false },
    { name: "Sesame Street", officialName: "Super-Automated Machine", source: "Sesame Street", inImage: false },
    { name: "SAM", officialName: "Super-Automated Machine", source: "Sesame Street", inImage: false },
    
    // The Reapers
    { name: "The Reapers", officialName: "The Reapers", source: "Mass Effect", inImage: false },
    { name: "Reapers", officialName: "The Reapers", source: "Mass Effect", inImage: false },
    { name: "Mass Effect", officialName: "The Reapers", source: "Mass Effect", inImage: false },
    { name: "Harbinger", officialName: "The Reapers", source: "Mass Effect", inImage: false },
    
    // Liberty Prime
    { name: "Liberty Prime", officialName: "Liberty Prime", source: "Fallout 3", inImage: false },
    { name: "Fallout", officialName: "Liberty Prime", source: "Fallout 3", inImage: false },
    { name: "Democracy is Non-Negotiable", officialName: "Liberty Prime", source: "Fallout 3", inImage: false },
    
    // Droideka
    { name: "Droideka", officialName: "Droideka", source: "Star Wars", inImage: false },
    { name: "Destroyer Droid", officialName: "Droideka", source: "Star Wars", inImage: false },
    { name: "Roller Droid", officialName: "Droideka", source: "Star Wars", inImage: false },
    
    // Tachikoma
    { name: "Tachikoma", officialName: "Tachikoma", source: "Ghost in the Shell", inImage: false },
    { name: "Ghost in the Shell", officialName: "Tachikoma", source: "Ghost in the Shell", inImage: false },
    { name: "Spider Tank", officialName: "Tachikoma", source: "Ghost in the Shell", inImage: false },
    { name: "Think Tank", officialName: "Tachikoma", source: "Ghost in the Shell", inImage: false },
    
    // Furby
    { name: "Furby", officialName: "Furby", source: "Furby", inImage: false },
    { name: "Tiger Electronics", officialName: "Furby", source: "Furby", inImage: false },
    
    // More Shogun Warriors
    { name: "Raydeen", officialName: "Raydeen", source: "Shogun Warriors", inImage: false },
    { name: "Dragun", officialName: "Dragun", source: "Shogun Warriors", inImage: false },
    { name: "Gaiking", officialName: "Gaiking", source: "Shogun Warriors", inImage: false },
    { name: "Goldorak", officialName: "Goldorak", source: "Shogun Warriors", inImage: false },
    { name: "UFO Robot Grendizer", officialName: "Goldorak", source: "Shogun Warriors", inImage: false },
    
    // Gypsy
    { name: "Gypsy", officialName: "Gypsy", source: "Mystery Science Theater 3000", inImage: false },
    
    // Dot Matrix
    { name: "Dot Matrix", officialName: "Dot Matrix", source: "Spaceballs", inImage: false },
    { name: "Spaceballs", officialName: "Dot Matrix", source: "Spaceballs", inImage: false },
    { name: "Joan Rivers", officialName: "Dot Matrix", source: "Spaceballs", inImage: false },
    
    // Pneuman
    { name: "Pneuman", officialName: "Pneuman", source: "Tom Strong", inImage: false },
    { name: "Pneumatic Man", officialName: "Pneuman", source: "Tom Strong", inImage: false },
    { name: "Tom Strong", officialName: "Pneuman", source: "Tom Strong", inImage: false },
    { name: "Steam Robot", officialName: "Pneuman", source: "Tom Strong", inImage: false },
    
    // X-51
    { name: "X-51", officialName: "X-51", source: "Machine Man", inImage: false },
    { name: "Machine Man", officialName: "X-51", source: "Machine Man", inImage: false },
    { name: "Aaron Stack", officialName: "X-51", source: "Machine Man", inImage: false },
    
    // Rodney Copperbottom
    { name: "Rodney Copperbottom", officialName: "Rodney Copperbottom", source: "Robots", inImage: false },
    { name: "Blue Sky Studios", officialName: "Rodney Copperbottom", source: "Robots", inImage: false },

    // Hymie
    { name: "Hymie", officialName: "Hymie", source: "Get Smart", inImage: false },
    { name: "Agent Hymie", officialName: "Hymie", source: "Get Smart", inImage: false },
    { name: "Get Smart", officialName: "Hymie", source: "Get Smart", inImage: false },
    
    // Mechani-Kong
    { name: "Mechani-Kong", officialName: "Mechani-Kong", source: "King Kong Escapes", inImage: false },
    { name: "King Kong Escapes", officialName: "Mechani-Kong", source: "King Kong Escapes", inImage: false },
    { name: "Mecha Kong", officialName: "Mechani-Kong", source: "King Kong Escapes", inImage: false },
    
    // Tomorrow Woman
    { name: "Tomorrow Woman", officialName: "Tomorrow Woman", source: "DC Comics", inImage: false },
    
    // Red Tornado
    { name: "Red Tornado", officialName: "Red Tornado", source: "DC Comics", inImage: false },
    { name: "Reddy", officialName: "Red Tornado", source: "DC Comics", inImage: false },
    
    // Robot Devil
    { name: "Robot Devil", officialName: "Robot Devil", source: "Futurama", inImage: false },
    { name: "Beelzebot", officialName: "Robot Devil", source: "Futurama", inImage: false },
    
    // Red Volcano
    { name: "Red Volcano", officialName: "Red Volcano", source: "DC Comics", inImage: false },
    
    // Hadaly
    { name: "Hadaly", officialName: "Hadaly", source: "The Future Eve", inImage: false },
    { name: "Future Eve", officialName: "Hadaly", source: "The Future Eve", inImage: false },
    
    // Robert The Robot
    { name: "Robert The Robot", officialName: "Robert The Robot", source: "Fireball XL5", inImage: false },
    { name: "Fireball XL5", officialName: "Robert The Robot", source: "Fireball XL5", inImage: false },
    
    // Norby
    { name: "Norby", officialName: "Norby", source: "Norby The Mixed-Up Robot", inImage: false },
    { name: "Mixed-Up Robot", officialName: "Norby", source: "Norby The Mixed-Up Robot", inImage: false },
    
    // Val
    { name: "Val", officialName: "Val", source: "Heartbeeps", inImage: false },
    
    // HERBIE
    { name: "HERBIE", officialName: "HERBIE", source: "Fantastic Four", inImage: false },
    { name: "Humanoid Experimental Robot B-type Integrated Electronics", officialName: "HERBIE", source: "Fantastic Four", inImage: false },
    
    // HELPeR
    { name: "HELPeR", officialName: "HELPeR", source: "Venture Brothers", inImage: false },
    { name: "Venture Brothers", officialName: "HELPeR", source: "Venture Brothers", inImage: false },
    { name: "Helper Robot", officialName: "HELPeR", source: "Venture Brothers", inImage: false },
    
    // Gonk
    { name: "Gonk", officialName: "Gonk", source: "Star Wars", inImage: false },
    { name: "Power Droid", officialName: "Gonk", source: "Star Wars", inImage: false },
    { name: "GNK", officialName: "Gonk", source: "Star Wars", inImage: false },
    
    // IG-88 (already exists)
    { name: "IG-88", officialName: "IG-88", source: "Star Wars", inImage: false },
    { name: "Assassin Droid", officialName: "IG-88", source: "Star Wars", inImage: false },
    { name: "Bounty Hunter Droid", officialName: "IG-88", source: "Star Wars", inImage: false },
    
    // R5-D4
    { name: "R5-D4", officialName: "R5-D4", source: "Star Wars", inImage: false },
    { name: "Bad Motivator", officialName: "R5-D4", source: "Star Wars", inImage: false },
    { name: "Red R2 Unit", officialName: "R5-D4", source: "Star Wars", inImage: false },
    
    // No! Robot
    { name: "No! Robot", officialName: "No! Robot", source: "They Might Be Giants", inImage: false },
    { name: "They Might Be Giants", officialName: "No! Robot", source: "They Might Be Giants", inImage: false },
    { name: "TMBG", officialName: "No! Robot", source: "They Might Be Giants", inImage: false },
    
    // Dynomutt
    { name: "Dynomutt", officialName: "Dynomutt", source: "Dynomutt, Dog Wonder", inImage: false },
    { name: "Dog Wonder", officialName: "Dynomutt", source: "Dynomutt, Dog Wonder", inImage: false },
    { name: "Blue Falcon", officialName: "Dynomutt", source: "Dynomutt, Dog Wonder", inImage: false },
    
    // More Transformers
    { name: "Megatron", officialName: "Megatron", source: "Transformers", inImage: false },
    { name: "Decepticon Leader", officialName: "Megatron", source: "Transformers", inImage: false },
    { name: "Galvatron", officialName: "Megatron", source: "Transformers", inImage: false },
    { name: "Starscream", officialName: "Starscream", source: "Transformers", inImage: false },
    { name: "Air Commander", officialName: "Starscream", source: "Transformers", inImage: false },
    { name: "Decepticon", officialName: "Starscream", source: "Transformers", inImage: false },
    { name: "Sentinel Prime", officialName: "Sentinel Prime", source: "Transformers", inImage: false },
    { name: "Vector Prime", officialName: "Vector Prime", source: "Transformers", inImage: false },
    { name: "Prima Nova", officialName: "Prima Nova", source: "Transformers", inImage: false },
    { name: "Rodimus Prime", officialName: "Rodimus Prime", source: "Transformers", inImage: false },
    { name: "Hot Rod", officialName: "Rodimus Prime", source: "Transformers", inImage: false },
    
    // Gir
    { name: "Gir", officialName: "Gir", source: "Invader Zim", inImage: false },
    { name: "GIR", officialName: "Gir", source: "Invader Zim", inImage: false },
    { name: "Invader Zim", officialName: "Gir", source: "Invader Zim", inImage: false },
    { name: "SIR Unit", officialName: "Gir", source: "Invader Zim", inImage: false },
    
    // Giant Robo
    { name: "Giant Robo", officialName: "Giant Robo", source: "Giant Robo", inImage: false },
    { name: "Daisaku", officialName: "Giant Robo", source: "Giant Robo", inImage: false },
    
    // KITT
    { name: "KITT", officialName: "KITT", source: "Knight Rider", inImage: false },
    { name: "Knight Industries Two Thousand", officialName: "KITT", source: "Knight Rider", inImage: false },
    { name: "Knight Rider", officialName: "KITT", source: "Knight Rider", inImage: false },
    { name: "Trans Am", officialName: "KITT", source: "Knight Rider", inImage: false },
    
    // RoboSapien
    { name: "RoboSapien", officialName: "RoboSapien", source: "WowWee", inImage: false },
    { name: "WowWee", officialName: "RoboSapien", source: "WowWee", inImage: false },
    
    // R.O.B.
    { name: "R.O.B.", officialName: "R.O.B.", source: "Nintendo", inImage: false },
    { name: "ROB", officialName: "R.O.B.", source: "Nintendo", inImage: false },
    { name: "Robotic Operating Buddy", officialName: "R.O.B.", source: "Nintendo", inImage: false },
    { name: "Nintendo Robot", officialName: "R.O.B.", source: "Nintendo", inImage: false },
    
    // Omnibot
    { name: "Omnibot", officialName: "Omnibot", source: "Tomy", inImage: false },
    
    // Mr. Machine
    { name: "Mr. Machine", officialName: "Mr. Machine", source: "Ideal Toy Company", inImage: false },
    { name: "Mister Machine", officialName: "Mr. Machine", source: "Ideal Toy Company", inImage: false },
    
    // Topo/BOB
    { name: "Topo", officialName: "Topo/BOB", source: "Androbot", inImage: false },
    { name: "BOB", officialName: "Topo/BOB", source: "Androbot", inImage: false },
    { name: "Androbot", officialName: "Topo/BOB", source: "Androbot", inImage: false },
    
    // FAKK
    { name: "FAKK", officialName: "FAKK", source: "Heavy Metal", inImage: false },
    { name: "Heavy Metal", officialName: "FAKK", source: "Heavy Metal", inImage: false },
    
    // Veritech
    { name: "Veritech", officialName: "Veritech", source: "Robotech", inImage: false },
    { name: "Robotech", officialName: "Veritech", source: "Robotech", inImage: false },
    { name: "Macross", officialName: "Veritech", source: "Robotech", inImage: false },
    { name: "Valkyrie", officialName: "Veritech", source: "Robotech", inImage: false },
    
    // Lore
    { name: "Lore", officialName: "Lore", source: "Star Trek", inImage: false },
    { name: "Data's Brother", officialName: "Lore", source: "Star Trek", inImage: false },
    
    // Werecar
    { name: "Werecar", officialName: "Werecar", source: "Futurama", inImage: false },
    
    // Ro-Man
    { name: "Ro-Man", officialName: "Ro-Man", source: "Robot Monster", inImage: false },
    { name: "Robot Monster", officialName: "Ro-Man", source: "Robot Monster", inImage: false },
    
    // Robot Archie
    { name: "Robot Archie", officialName: "Robot Archie", source: "Lion Comics", inImage: false },
    { name: "Archie Comics", officialName: "Robot Archie", source: "Lion Comics", inImage: false },
    
    // More Futurama robots
    { name: "Reverend Preacherbot", officialName: "Reverend Preacherbot", source: "Futurama", inImage: false },
    { name: "Preacherbot", officialName: "Reverend Preacherbot", source: "Futurama", inImage: false },
    
    { name: "Kwaanzabot", officialName: "Kwaanzabot", source: "Futurama", inImage: false },
    { name: "Kwanzaa Bot", officialName: "Kwaanzabot", source: "Futurama", inImage: false },
    
    { name: "Hedonismbot", officialName: "Hedonismbot", source: "Futurama", inImage: false },
    { name: "Hedonism Bot", officialName: "Hedonismbot", source: "Futurama", inImage: false },
    
    { name: "Donbot", officialName: "Donbot", source: "Futurama", inImage: false },
    { name: "Don Bot", officialName: "Donbot", source: "Futurama", inImage: false },
    { name: "Robot Godfather", officialName: "Donbot", source: "Futurama", inImage: false },
    
    { name: "Joey Mousepad", officialName: "Joey Mousepad", source: "Futurama", inImage: false },
    { name: "Mouse Pad", officialName: "Joey Mousepad", source: "Futurama", inImage: false },
    
    { name: "Tinny Tim", officialName: "Tinny Tim", source: "Futurama", inImage: false },
    { name: "Tiny Tim", officialName: "Tinny Tim", source: "Futurama", inImage: false },
    
    // Talos
    { name: "Talos", officialName: "Talos", source: "Greek Mythology", inImage: false },
    { name: "Argonautica", officialName: "Talos", source: "Greek Mythology", inImage: false },
    { name: "Bronze Giant", officialName: "Talos", source: "Greek Mythology", inImage: false },
    { name: "Crete Guardian", officialName: "Talos", source: "Greek Mythology", inImage: false },
    
    // Steam Man
    { name: "Steam Man", officialName: "Steam Man", source: "Steam Man Of The Prairies", inImage: false },
    { name: "Steam Man of the Prairies", officialName: "Steam Man", source: "Steam Man Of The Prairies", inImage: false },
    { name: "Edward Ellis", officialName: "Steam Man", source: "Steam Man Of The Prairies", inImage: false },
    
    // Jana
    { name: "Jana", officialName: "Jana", source: "The Twilight Zone", inImage: false },
    
    // Torg
    { name: "Torg", officialName: "Torg", source: "Santa Claus Conquers The Martians", inImage: false },
    { name: "Santa Claus Conquers The Martians", officialName: "Torg", source: "Santa Claus Conquers The Martians", inImage: false },
    { name: "Martian Robot", officialName: "Torg", source: "Santa Claus Conquers The Martians", inImage: false },
    
    // Pneumon
    { name: "Pneumon", officialName: "Pneumon", source: "Tom Strong", inImage: false },
    
    // Steelgauntlet
    { name: "Steelgauntlet", officialName: "Steelgauntlet", source: "The 49ers", inImage: false },
    { name: "The 49ers", officialName: "Steelgauntlet", source: "The 49ers", inImage: false },
    { name: "Steel Gauntlet", officialName: "Steelgauntlet", source: "The 49ers", inImage: false },
    
    // Zoe Graystone
    { name: "Zoe Graystone", officialName: "Zoe Graystone", source: "Caprica", inImage: false },
    { name: "Caprica", officialName: "Zoe Graystone", source: "Caprica", inImage: false },
    { name: "Zoe-A", officialName: "Zoe Graystone", source: "Caprica", inImage: false },
    
    // Lal
    { name: "Lal", officialName: "Lal", source: "Star Trek", inImage: false },
    { name: "Data's Daughter", officialName: "Lal", source: "Star Trek", inImage: false },
    
    // Additional popular video game robots
    { name: "EDI", officialName: "EDI", source: "Mass Effect", inImage: false },
    { name: "Enhanced Defense Intelligence", officialName: "EDI", source: "Mass Effect", inImage: false },
    
    { name: "Legion", officialName: "Legion", source: "Mass Effect", inImage: false },
    { name: "Geth", officialName: "Legion", source: "Mass Effect", inImage: false },
    
    { name: "Bastion", officialName: "Bastion", source: "Overwatch", inImage: false },
    { name: "Overwatch", officialName: "Bastion", source: "Overwatch", inImage: false },
    
    { name: "Zenyatta", officialName: "Zenyatta", source: "Overwatch", inImage: false },
    { name: "Omnic Monk", officialName: "Zenyatta", source: "Overwatch", inImage: false },
    
    { name: "Orisa", officialName: "Orisa", source: "Overwatch", inImage: false },
    
    // Detroit: Become Human
    { name: "Connor", officialName: "Connor", source: "Detroit: Become Human", inImage: false },
    { name: "RK800", officialName: "Connor", source: "Detroit: Become Human", inImage: false },
    
    { name: "Markus", officialName: "Markus", source: "Detroit: Become Human", inImage: false },
    { name: "RK200", officialName: "Markus", source: "Detroit: Become Human", inImage: false },
    
    { name: "Kara", officialName: "Kara", source: "Detroit: Become Human", inImage: false },
    { name: "AX400", officialName: "Kara", source: "Detroit: Become Human", inImage: false },
    
    // I, Robot movie
    { name: "NS-5", officialName: "NS-5", source: "I, Robot (Movie)", inImage: false },
    { name: "VIKI", officialName: "VIKI", source: "I, Robot (Movie)", inImage: false },
    { name: "Virtual Interactive Kinetic Intelligence", officialName: "VIKI", source: "I, Robot (Movie)", inImage: false },
    
    // Westworld
    { name: "Dolores", officialName: "Dolores", source: "Westworld (HBO)", inImage: false },
    { name: "Dolores Abernathy", officialName: "Dolores", source: "Westworld (HBO)", inImage: false },
    
    { name: "Maeve", officialName: "Maeve", source: "Westworld (HBO)", inImage: false },
    { name: "Maeve Millay", officialName: "Maeve", source: "Westworld (HBO)", inImage: false },
    
    { name: "Host", officialName: "Host", source: "Westworld (HBO)", inImage: false },
    { name: "Westworld Host", officialName: "Host", source: "Westworld (HBO)", inImage: false },
    
    // Blade Runner
    { name: "Roy Batty", officialName: "Roy Batty", source: "Blade Runner", inImage: false },
    { name: "Replicant", officialName: "Roy Batty", source: "Blade Runner", inImage: false },
    { name: "Nexus 6", officialName: "Roy Batty", source: "Blade Runner", inImage: false },
    
    { name: "Pris", officialName: "Pris", source: "Blade Runner", inImage: false },
    { name: "Basic Pleasure Model", officialName: "Pris", source: "Blade Runner", inImage: false },
    
    { name: "Rachael", officialName: "Rachael", source: "Blade Runner", inImage: false },
    { name: "Tyrell Corporation", officialName: "Rachael", source: "Blade Runner", inImage: false },
    
    // Aliens franchise
    { name: "Bishop", officialName: "Bishop", source: "Aliens", inImage: false },
    { name: "Synthetic", officialName: "Bishop", source: "Aliens", inImage: false },
    { name: "Weyland-Yutani", officialName: "Bishop", source: "Aliens", inImage: false },
        
    { name: "Ash", officialName: "Ash", source: "Alien", inImage: false },
    { name: "Science Officer", officialName: "Ash", source: "Alien", inImage: false },
    
    { name: "Call", officialName: "Call", source: "Alien: Resurrection", inImage: false },
    { name: "Auton", officialName: "Call", source: "Alien: Resurrection", inImage: false },
    
    // Additional classic robots
    { name: "Tobor", officialName: "Tobor", source: "Tobor the Great", inImage: false },
    { name: "Tobor the Great", officialName: "Tobor", source: "Tobor the Great", inImage: false },
    
    //real robots
    { name: "Atlas BD", officialName: "Atlas BD", source: "Boston Dynamics", inImage: false },
    { name: "Spot", officialName: "Spot", source: "Boston Dynamics", inImage: false },
    { name: "Ameca", officialName: "Ameca", source: "Engineered Arts", inImage: false },
    { name: "Nadine", officialName: "Nadine", source: "Nanyang TU", inImage: false },
    { name: "Asimo", officialName: "Asimo", source: "Honda", inImage: false },
    { name: "Sophia", officialName: "Sophia", source: "Hanson Robotics", inImage: false },
    { name: "Optimus Gen-2", officialName: "Optimus Gen-2", source: "Tesla Bot", inImage: false },
    { name: "Pepper", officialName: "Pepper", source: "SoftBank Robotics", inImage: false },
    { name: "Apollo", officialName: "Apollo", source: "Apptronik", inImage: false },
    
    //newer robots
    { name: "Metal Gear Rex", officialName: "Metal Gear Rex", source: "Metal Gear Series", inImage: false },
    { name: "Intergalactic", officialName: "Intergalactic Robot", source: "Beastie Boys", inImage: false },
    { name: "Klara", officialName: "Klara", source: "Klara and the Sun", inImage: false },
    { name: "Pink Robots", officialName: "The Pink Robots", source: "The Flaming Lips", inImage: false },
    { name: "Mars Rover", officialName: "Mars Rover", source: "NASA", inImage: false },
    { name: "V'Ger", officialName: "V'Ger", source: "Star Trek the Motion Picture", inImage: false },
    { name: "Voyager", officialName: "Voyager", source: "NASA", inImage: false },
    { name: "Iris", officialName: "Iris", source: "Companion", inImage: false },
    { name: "Herman", officialName: "Herman", source: "The Electric State", inImage: false },
    { name: "Mr. Peanut", officialName: "Mr. Peanut", source: "The Electric State", inImage: false },
    { name: "Peanut", officialName: "Mr. Peanut", source: "The Electric State", inImage: false },
    { name: "Penny Pal", officialName: "Penny Pal", source: "The Electric State", inImage: false },
    { name: "P.C.", officialName: "P.C.", source: "The Electric State", inImage: false },
    { name: "Cosmo", officialName: "Cosmo", source: "The Electric State", inImage: false },
    { name: "Popfly", officialName: "Popfly", source: "The Electric State", inImage: false },
    { name: "Perplexo", officialName: "Perplexo", source: "The Electric State", inImage: false },
    { name: "Wolfe", officialName: "Wolfe", source: "The Electric State", inImage: false },
    { name: "Blitz", officialName: "Blitz", source: "The Electric State", inImage: false },
    { name: "Clem", officialName: "Clem", source: "The Electric State", inImage: false },
    { name: "Skeevy Bot", officialName: "Skeevy Bot", source: "The Electric State", inImage: false },
    { name: "Garbage Bot", officialName: "Garbage Bot", source: "The Electric State", inImage: false },

    // Bernard (Westworld)
    { name: "Bernard", officialName: "Bernard", source: "Westworld", inImage: false },
    { name: "Bernard Lowe", officialName: "Bernard", source: "Westworld", inImage: false },

    // Niska (Humans)
    { name: "Niska", officialName: "Niska", source: "Humans", inImage: false },

    // Calculon (Futurama)
    { name: "Calculon", officialName: "Calculon", source: "Futurama", inImage: false },

    // Walter (Alien: Covenant)
    { name: "Walter", officialName: "Walter", source: "Alien: Covenant", inImage: false },

    // Officer K (Blade Runner 2049)
    { name: "Officer K", officialName: "Officer K", source: "Blade Runner 2049", inImage: false },
    { name: "Joe", officialName: "Officer K", source: "Blade Runner 2049", inImage: false },

    // HK-47 (Star Wars: Knights of the Old Republic)
    { name: "HK-47", officialName: "HK-47", source: "Star Wars: Knights of the Old Republic", inImage: false },

    // K.A.R.R. (Knight Rider)
    { name: "KARR", officialName: "K.A.R.R.", source: "Knight Rider", inImage: false },
    { name: "K.A.R.R.", officialName: "K.A.R.R.", source: "Knight Rider", inImage: false },

    // RX-78-2 Gundam (Mobile Suit Gundam)
    { name: "Gundam", officialName: "RX-78-2 Gundam", source: "Mobile Suit Gundam", inImage: false },
    { name: "RX-78-2", officialName: "RX-78-2 Gundam", source: "Mobile Suit Gundam", inImage: false },

    // Evangelion Unit-01 (Neon Genesis Evangelion)
    { name: "Evangelion", officialName: "Evangelion Unit-01", source: "Neon Genesis Evangelion", inImage: false },
    { name: "Unit-01", officialName: "Evangelion Unit-01", source: "Neon Genesis Evangelion", inImage: false },
    { name: "Eva Unit 01", officialName: "Evangelion Unit-01", source: "Neon Genesis Evangelion", inImage: false },

    // Chi (Chobits)
    { name: "Chi", officialName: "Chi", source: "Chobits", inImage: false },

    // M3GAN (M3GAN)
    { name: "M3GAN", officialName: "M3GAN", source: "M3GAN", inImage: false },
    { name: "Megan", officialName: "M3GAN", source: "M3GAN", inImage: false },

    // Andrew (Bicentennial Man)
    { name: "Andrew", officialName: "Andrew", source: "Bicentennial Man", inImage: false },
    { name: "Andrew Martin", officialName: "Andrew", source: "Bicentennial Man", inImage: false },

    // Stepford Wife (The Stepford Wives)
    { name: "Stepford Wife", officialName: "Stepford Wife", source: "The Stepford Wives", inImage: false },

    // Figure 01 (Figure AI - real-world robot)
    { name: "Figure 01", officialName: "Figure 01", source: "Figure AI", inImage: false },

    // Digit (Agility Robotics - real-world robot)
    { name: "Digit", officialName: "Digit", source: "Agility Robotics", inImage: false },

    // Uniblab (The Jetsons)
    { name: "Uniblab", officialName: "Uniblab", source: "The Jetsons", inImage: false },

    // Cherry 2000 (Cherry 2000)
    { name: "Cherry 2000", officialName: "Cherry 2000", source: "Cherry 2000", inImage: false },

    // Fender (Robots, 2005)
    { name: "Fender", officialName: "Fender", source: "Robots", inImage: false },

    // R. Daneel Olivaw (Isaac Asimov's Robot novels)
    { name: "R. Daneel Olivaw", officialName: "R. Daneel Olivaw", source: "Isaac Asimov's Robot novels", inImage: false },
    { name: "Daneel", officialName: "R. Daneel Olivaw", source: "Isaac Asimov's Robot novels", inImage: false },

    // Speedy (Isaac Asimov's "Runaround")
    { name: "Speedy", officialName: "Speedy", source: "Isaac Asimov's \"Runaround\"", inImage: false },
    { name: "SPD-13", officialName: "Speedy", source: "Isaac Asimov's \"Runaround\"", inImage: false },

    // Adam Link (Adam Link short stories, 1939)
    { name: "Adam Link", officialName: "Adam Link", source: "Adam Link short stories", inImage: false },

    // Elektro (1939 New York World's Fair - real historical robot)
    { name: "Elektro", officialName: "Elektro", source: "1939 New York World's Fair", inImage: false },

    // The Mechanical Turk (18th-century chess-playing automaton hoax)
    { name: "The Mechanical Turk", officialName: "The Mechanical Turk", source: "18th-century automaton hoax", inImage: false },
    { name: "Mechanical Turk", officialName: "The Mechanical Turk", source: "18th-century automaton hoax", inImage: false },

    // Olympia (E.T.A. Hoffmann's "The Sandman" / Coppelia)
    { name: "Olympia", officialName: "Olympia", source: "The Sandman", inImage: false },
    { name: "Coppelia", officialName: "Olympia", source: "The Sandman", inImage: false },

    // The Golem (Jewish folklore)
    { name: "Golem", officialName: "The Golem", source: "Jewish folklore", inImage: false },
    { name: "Golem of Prague", officialName: "The Golem", source: "Jewish folklore", inImage: false },

    // Colossus (Colossus: The Forbin Project, 1970)
    { name: "Colossus", officialName: "Colossus", source: "Colossus: The Forbin Project", inImage: false },

    // WOPR (WarGames, 1983)
    { name: "WOPR", officialName: "WOPR", source: "WarGames", inImage: false },
    { name: "War Operation Plan Response", officialName: "WOPR", source: "WarGames", inImage: false },

    // The Twonky (The Twonky)
    { name: "The Twonky", officialName: "The Twonky", source: "The Twonky", inImage: false },
    { name: "Twonky", officialName: "The Twonky", source: "The Twonky", inImage: false },

    // Doraemon (Doraemon)
    { name: "Doraemon", officialName: "Doraemon", source: "Doraemon", inImage: false },

    // Grimlock (Transformers)
    { name: "Grimlock", officialName: "Grimlock", source: "Transformers", inImage: false },

    // Optimus Primal (Transformers: Beast Wars)
    { name: "Optimus Primal", officialName: "Optimus Primal", source: "Transformers: Beast Wars", inImage: false },

    // Robotman (DC Comics / Doom Patrol)
    { name: "Robotman", officialName: "Robotman", source: "DC Comics", inImage: false },
    { name: "Cliff Steele", officialName: "Robotman", source: "DC Comics", inImage: false },

    // Rom the Spaceknight (Marvel Comics)
    { name: "Rom", officialName: "Rom the Spaceknight", source: "Marvel Comics", inImage: false },
    { name: "Rom the Spaceknight", officialName: "Rom the Spaceknight", source: "Marvel Comics", inImage: false },

    // Pluto / Gesicht (Pluto, manga by Naoki Urasawa)
    { name: "Pluto", officialName: "Gesicht", source: "Pluto", inImage: false },
    { name: "Gesicht", officialName: "Gesicht", source: "Pluto", inImage: false },

    // Metal Mickey (British TV)
    { name: "Metal Mickey", officialName: "Metal Mickey", source: "Metal Mickey", inImage: false },

    // The Machine (Person of Interest)
    { name: "The Machine", officialName: "The Machine", source: "Person of Interest", inImage: false },

    // M-5 (Star Trek: The Original Series)
    { name: "M-5", officialName: "M-5", source: "Star Trek: The Original Series", inImage: false },
    { name: "M5", officialName: "M-5", source: "Star Trek: The Original Series", inImage: false },

    // ===== CYBORGS (part-human, part-machine - not full robots/androids) =====

    // RoboCop
    { name: "RoboCop", officialName: "RoboCop", source: "RoboCop", inImage: false },

    // Cyberman
    { name: "Cyberman", officialName: "Cyberman", source: "Doctor Who", inImage: false },

    // General Grievous
    { name: "General Grievous", officialName: "General Grievous", source: "Star Wars: Prequels", inImage: false },
    { name: "Cyborg General", officialName: "General Grievous", source: "Star Wars: Prequels", inImage: false },
    { name: "Four Lightsaber", officialName: "General Grievous", source: "Star Wars: Prequels", inImage: false },

    // Alita
    { name: "Alita", officialName: "Alita", source: "Alita: Battle Angel", inImage: false },

    // Cyborg (DC Comics / Teen Titans)
    { name: "Cyborg", officialName: "Cyborg", source: "DC Comics", inImage: false },
    { name: "Victor Stone", officialName: "Cyborg", source: "DC Comics", inImage: false },

    // Darth Vader (Star Wars)
    { name: "Darth Vader", officialName: "Darth Vader", source: "Star Wars", inImage: false },
    { name: "Anakin Skywalker", officialName: "Darth Vader", source: "Star Wars", inImage: false },
    { name: "Vader", officialName: "Darth Vader", source: "Star Wars", inImage: false },

    // Winter Soldier (Marvel Comics)
    { name: "Winter Soldier", officialName: "Winter Soldier", source: "Marvel Comics", inImage: false },
    { name: "Bucky Barnes", officialName: "Winter Soldier", source: "Marvel Comics", inImage: false },
    { name: "Bucky", officialName: "Winter Soldier", source: "Marvel Comics", inImage: false },

    // Steve Austin (The Six Million Dollar Man)
    { name: "Steve Austin", officialName: "Steve Austin", source: "The Six Million Dollar Man", inImage: false },
    { name: "Six Million Dollar Man", officialName: "Steve Austin", source: "The Six Million Dollar Man", inImage: false },

    // Jaime Sommers (The Bionic Woman)
    { name: "Jaime Sommers", officialName: "Jaime Sommers", source: "The Bionic Woman", inImage: false },
    { name: "Bionic Woman", officialName: "Jaime Sommers", source: "The Bionic Woman", inImage: false },

    // Molly Millions (Neuromancer)
    { name: "Molly Millions", officialName: "Molly Millions", source: "Neuromancer", inImage: false },
    { name: "Neuromancer", officialName: "Molly Millions", source: "Neuromancer", inImage: false },

    // Major Motoko Kusanagi (Ghost in the Shell)
    { name: "Motoko Kusanagi", officialName: "Major Motoko Kusanagi", source: "Ghost in the Shell", inImage: false },
    { name: "Major Motoko Kusanagi", officialName: "Major Motoko Kusanagi", source: "Ghost in the Shell", inImage: false },
    { name: "The Major", officialName: "Major Motoko Kusanagi", source: "Ghost in the Shell", inImage: false },

    // Batou (Ghost in the Shell)
    { name: "Batou", officialName: "Batou", source: "Ghost in the Shell", inImage: false },

    // Adam Jensen (Deus Ex: Human Revolution)
    { name: "Adam Jensen", officialName: "Adam Jensen", source: "Deus Ex: Human Revolution", inImage: false },
    { name: "Deus Ex", officialName: "Adam Jensen", source: "Deus Ex: Human Revolution", inImage: false },

    // Cable (Marvel Comics)
    { name: "Cable", officialName: "Cable", source: "Marvel Comics", inImage: false },
    { name: "Nathan Summers", officialName: "Cable", source: "Marvel Comics", inImage: false },

    // Deathlok (Marvel Comics)
    { name: "Deathlok", officialName: "Deathlok", source: "Marvel Comics", inImage: false },

    // Metallo (DC Comics)
    { name: "Metallo", officialName: "Metallo", source: "DC Comics", inImage: false },

    // Cyborg Superman (DC Comics)
    { name: "Cyborg Superman", officialName: "Cyborg Superman", source: "DC Comics", inImage: false },
    { name: "Hank Henshaw", officialName: "Cyborg Superman", source: "DC Comics", inImage: false },

    // Doctor Octopus (Marvel Comics)
    { name: "Doctor Octopus", officialName: "Doctor Octopus", source: "Marvel Comics", inImage: false },
    { name: "Doc Ock", officialName: "Doctor Octopus", source: "Marvel Comics", inImage: false },
    { name: "Otto Octavius", officialName: "Doctor Octopus", source: "Marvel Comics", inImage: false },

    // Wolverine (Marvel Comics)
    { name: "Wolverine", officialName: "Wolverine", source: "Marvel Comics", inImage: false },
    { name: "Logan", officialName: "Wolverine", source: "Marvel Comics", inImage: false },

    // Genos (One Punch Man)
    { name: "Genos", officialName: "Genos", source: "One Punch Man", inImage: false },

    // Genji (Overwatch)
    { name: "Genji", officialName: "Genji", source: "Overwatch", inImage: false },

    // Raiden (Metal Gear Rising: Revengeance)
    { name: "Raiden", officialName: "Raiden", source: "Metal Gear Rising: Revengeance", inImage: false },

    // Cyborg 009
    { name: "Cyborg 009", officialName: "Cyborg 009", source: "Cyborg 009", inImage: false },
    { name: "Joe Shimamura", officialName: "Cyborg 009", source: "Cyborg 009", inImage: false },

    // Sektor (Mortal Kombat)
    { name: "Sektor", officialName: "Sektor", source: "Mortal Kombat", inImage: false },

    // Smoke (Mortal Kombat)
    { name: "Smoke", officialName: "Smoke", source: "Mortal Kombat", inImage: false },

    // ===== NEW VERSION TO COME =====
    // Identified from the 2025 artwork (not yet live - old 2018 art is still in the game).
    // Added here as decoys for now so they don't break the current 91-answer image.
    // When the art/coordinates get updated: flip these to inImage:true, add coordinates
    // in robotCoordinates.js, and flip the existing "Rozzum" entry above to inImage:true too.

    // Mother (replaces Bender's old spot)
    { name: "Mother", officialName: "Mother", source: "Mother/Android", inImage: false },

    // SAR (Kill Command)
    { name: "SAR", officialName: "SAR", source: "Kill Command", inImage: false },
    { name: "Kill Command", officialName: "SAR", source: "Kill Command", inImage: false },

    // The Fixer (*batteries not included)
    { name: "Fixer", officialName: "Fixer", source: "*batteries not included", inImage: false },
    { name: "The Fixer", officialName: "Fixer", source: "*batteries not included", inImage: false },
    { name: "Batteries Not Included", officialName: "Fixer", source: "*batteries not included", inImage: false },

    // Murometz Titan (War Robots)
    { name: "Murometz", officialName: "Murometz", source: "War Robots", inImage: false },
    { name: "Murometz Titan", officialName: "Murometz", source: "War Robots", inImage: false },
    { name: "War Robots", officialName: "Murometz", source: "War Robots", inImage: false },

    // Ron (Ron's Gone Wrong)
    { name: "Ron", officialName: "Ron", source: "Ron's Gone Wrong", inImage: false },
    { name: "B-bot", officialName: "Ron", source: "Ron's Gone Wrong", inImage: false },
    { name: "Ron's Gone Wrong", officialName: "Ron", source: "Ron's Gone Wrong", inImage: false }
];